import Component_HighlightLayer_ce99e7bc805b96166e7cf160282a46e1 from "../../../../content/examples/special-fx/highlight-layer/HighlightLayer";
import Devtool_HighlightLayer_ce99e7bc805b96166e7cf160282a46e1 from "!!@devtool/loader!../../../../content/examples/special-fx/highlight-layer/HighlightLayer";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_HighlightLayer_ce99e7bc805b96166e7cf160282a46e1,
  Devtool_HighlightLayer_ce99e7bc805b96166e7cf160282a46e1,
  DevTool,
  React
};